<template>
  <div>
    <h2>Upload tekniker-data</h2>
    <ion-label>Vil du opdatere teknikere-data?</ion-label>
    <br />
    <input
      type="file"
      id="fileInput"
      ref="file"
      accept=".csv"
      @change="fileReader()"
    />
    <hr />
    {{ data.length }} / {{ csvArray.length }} (Fejl: {{ errors.length }})

    <hr />
    <div v-if="fileDone">
      <ion-button expand="block" @click="savePersons()">Gem data</ion-button>
    </div>
    <br />
    <ion-label color="primary" v-if="personMessage.length > 0">{{
      personMessage
    }}</ion-label>
    <div v-if="errors.length > 0 && fileDone">
      <h2>Fejl</h2>
      <ion-label>Fejl bliver ikke gemt i data!</ion-label>
      <ul style="padding: 0; list-style:none;">
        <li v-for="error in errors" :key="error.Initialer">
          <b>{{ error.Initialer }}</b> - {{ error.Adresse }},
          {{ error.Postnummer }} {{ error.By }}<br />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Papa from "papaparse";
import { utm32ToWgs84 } from "@/utils/geo";

import { mapGetters } from "vuex";
import { IonButton, IonLabel } from "@ionic/vue";

const ADRESSEVAELGER_URL = "https://adressevaelger.dk";
// Offentligt API-token, ligger alligevel i den udleverede bundle
const ADRESSEVAELGER_TOKEN =
  "Fic6pFCUGlDYKy8zH3KNtRq0gZLBYOX4aNUMDaNXV7hVWi31xVdDHr1uzLdVfZnwIwowE58bjiv6afKW0jVVsluP0zxTjxDbh";

export default {
  components: {
    IonButton,
    IonLabel,
  },
  data() {
    return {
      fileDone: false,
      fileName: "",
      csvArray: [],
      data: [],
      errors: [],
      personMessage: "",
    };
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    savePersons() {
      var app = this;
      if (this.data.length === 0) {
        this.personMessage = "Ingen data at gemme - eksisterende data er uændret.";
        return;
      }
      if (
        this.errors.length > 0 &&
        !confirm(
          this.errors.length +
            " personer kunne ikke geokodes og bliver IKKE gemt. Gem alligevel?"
        )
      ) {
        return;
      }
      this.$store.commit("saveData", this.data);

      var result = this.$store.dispatch("saveToBlobStorage", {
        data: this.data,
        blobName: "persons",
      });

      result.then(function(data) {
        app.personMessage = data;
      });
    },
    async fileReader() {
      var app = this;
      var oFile = this.$refs.file.files[0];

      //reset
      this.data = [];
      this.csvArray = [];
      this.errors = [];
      this.fileDone = false;
      this.personMessage = "";

      Papa.parse(oFile, {
        header: true,
        download: true,
        dynamicTyping: true,
        encoding: "UTF-8",
        skipEmptyLines: "greedy",
        complete: async function(results) {
          app.csvArray = results.data;

          // Få kald ad gangen for ikke at overbelaste API'et
          const batchSize = 5;
          for (let i = 0; i < app.csvArray.length; i += batchSize) {
            const batch = app.csvArray.slice(i, i + batchSize);
            await Promise.all(
              batch.map(async (element) => {
                const person = await app.addGeoData(3, element);
                if (person != null) {
                  app.data.push(person);
                } else {
                  app.errors.push(element);
                }
              })
            );
          }
          app.fileDone = true;
        },
      });
    },
    // Adressevælgeren (Klimadatastyrelsen).
    // Trin 1: søg adressen -> id. Trin 2: slå id op -> koordinater (EPSG:25832).
    // Gemmer x = længdegrad og y = breddegrad (WGS84), som resten af appen forventer.
    async addGeoData(retries, item, backoff = 1000) {
      const tekst = [item.Adresse, item.Postnummer, item.By]
        .filter((v) => v != null && v !== "")
        .join(" ")
        .trim();
      if (!tekst) return null;

      try {
        const search = await axios.get(ADRESSEVAELGER_URL + "/husnumre/soeg", {
          params: { tekst: tekst, token: ADRESSEVAELGER_TOKEN },
        });
        const hits = search.data.fund || [];
        if (hits.length === 0) return null;

        const id = hits[0].id;
        const lookup = await axios.get(
          ADRESSEVAELGER_URL + "/husnumre/" + id,
          { params: { token: ADRESSEVAELGER_TOKEN } }
        );
        const koord = lookup.data.husnummer.adgangspunkt.koordinater;
        const pos = utm32ToWgs84(koord.x, koord.y);
        item.x = pos.lon;
        item.y = pos.lat;
        return item;
      } catch (error) {
        if (retries > 0) {
          await new Promise((resolve) => setTimeout(resolve, backoff));
          return this.addGeoData(retries - 1, item, backoff * 2);
        }
        console.log("Geokodning fejlede", tekst, error);
        return null;
      }
    },
  },
};
</script>
